/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let shopBase = window._env_.VUE_APP_SHOP_HOST
export const getFairRewardTable = params => {
  return axios.post(`${base}/query_fair_reward_log`, params)
}
export const addRewardLogistics = params => {
  return axios.post(`${base}/add_reward_deliver`, params)
}
export const getLogisticsCompany = params => {
  return axios.get(`${shopBase}/core/delivers`, {params})
}
export const getRewardLogistics = id => {
  return axios.get(`${base}/get_reward_deliver_` + id)
}



// WEBPACK FOOTER //
// ./src/views/fair-reward/fairReward.api.js